import styled from 'styled-components';
export var Label = styled.label.withConfig({
  displayName: "style__Label",
  componentId: "volst5-0"
})(["width:58%;"]);
export var Box = styled.label.withConfig({
  displayName: "style__Box",
  componentId: "volst5-1"
})(["width:50%;"]);